import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/coloring/ColoringCreatePage.tsx");
